// Models

// Constants
import {
    FETCH_INVOICE_LIST_REQUEST,
    FETCH_INVOICE_LIST_SUCCESS,
    FETCH_INVOICE_LIST_ERROR,
    SHOW_INVOICE_LOADER,
    HIDE_INVOICE_LOADER,
    DOWNLOAD_INVOICE_FILE_SUCCESS,
    DOWNLOAD_INVOICE_FILE_ERROR,
    DOWNLOAD_INVOICE_FILE_REQUEST,
    UPDATE_INVOICE_PAYMENT_STATUS_REQUEST,
    UPDATE_INVOICE_PAYMENT_STATUS_SUCCESS,
    UPDATE_INVOICE_PAYMENT_STATUS_ERROR,
    UPDATE_INVOICE_PAYMENT_STATUS_RESET,
} from './invoice.constants';
import InvoiceModel from './model/InvoiceModel';

export const initialState = {
    tableData: [],
    pagination: {},
    error: {},
    activeReports: {
        reports: {},
        error: {},
    },
    isLoading: false,
    generatedFile: {
        isSuccess: false,
        error: {},
    },
};

export const invoiceReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_INVOICE_LIST_REQUEST:
            return {
                ...state,
                error: {},
            };
        case FETCH_INVOICE_LIST_SUCCESS: {
            const invoiceList = new InvoiceModel(action.payload);
            return {
                ...state,
                ...invoiceList,
                error: {},
            };
        }
        case FETCH_INVOICE_LIST_ERROR:
            return {
                ...state,
                error: { ...action.payload.error },
            };
        case UPDATE_INVOICE_PAYMENT_STATUS_REQUEST:
            return {
                ...state,
                error: {},
                isStatusLoading: true,
            };
        case UPDATE_INVOICE_PAYMENT_STATUS_SUCCESS: {
            return {
                ...state,
                isSuccessfulRefund: true,
                isStatusLoading: false,
                statusUpdateError: {},
            };
        }
        case UPDATE_INVOICE_PAYMENT_STATUS_ERROR:
            return {
                ...state,
                isSuccessfulRefund: false,
                isStatusLoading: false,
                statusUpdateError: { ...action.payload.error },
            };
        case UPDATE_INVOICE_PAYMENT_STATUS_RESET:
            return {
                ...state,
                isSuccessfulRefund: false,
                isStatusLoading: false,
                statusUpdateError: {},
            };
        case DOWNLOAD_INVOICE_FILE_REQUEST:
            return {
                ...state,
                generatedFile: { ...action.payload, isSuccess: false },
            };
        case DOWNLOAD_INVOICE_FILE_SUCCESS:
            return {
                ...state,
                generatedFile: { ...action.payload, isSuccess: true },
            };
        case DOWNLOAD_INVOICE_FILE_ERROR:
            return {
                ...state,
                generatedFile: { ...action.payload, isSuccess: false },
            };

        case SHOW_INVOICE_LOADER:
            return { ...state, isLoading: true };
        case HIDE_INVOICE_LOADER:
            return { ...state, isLoading: false };
        default:
            return state;
    }
};
